"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEValidator = void 0;
const config_1 = require("../../config");
const CountryValidator_class_1 = require("../CountryValidator.class");
const Util = require("../../util");
const bankAccountNamingRules_1 = require("./bankAccountNamingRules");
class SEValidator extends CountryValidator_class_1.CountryValidator {
    constructor(channel = config_1.CountryChannel.SE) {
        super(channel);
    }
    isValidPersonalId(value, opts = {}) {
        if (typeof value !== 'string') {
            return false;
        }
        if (typeof opts.type === 'undefined' || opts.type === 'short') { // use short by default
            return SEValidator.isValidShortPersonalIdFormat(value) &&
                SEValidator.isValidCheckSumOfShortPersonalId(value);
        }
        if (opts.type === 'long') {
            return SEValidator.isValidLongPersonalIdFormat(value) &&
                SEValidator.isValidCheckSumOfLongPersonalId(value);
        }
        return false;
    }
    isValidBankAccountWhenBankUnknown(number, opts = {}) {
        opts = { normalize: true, ...opts };
        if (typeof number !== 'string') {
            return false;
        }
        const normalizedAccountNumber = opts.normalize ? number.replace(/\D/g, '') : number;
        const bank = bankAccountNamingRules_1.bankAccountNamingRules.find(bank => bank.regex.test(normalizedAccountNumber));
        if (!bank) {
            return false;
        }
        return this.isValidBankAccountWhenBankKnown(normalizedAccountNumber, bank);
    }
    isValidBankAccountWhenBankKnown(accnum, bank) {
        const clearing = accnum.substr(0, accnum.charAt(0) === '8' ? 5 : 4);
        const number = bank.type === 1
            ? accnum.substr(-7)
            : bank.type === 2 && bank.comment === 2
                ? accnum.substr(-9)
                : bank.type === 2 && bank.comment === 3 && accnum.charAt(0) === '8'
                    ? accnum.substr(5)
                    : bank.type === 2 && bank.comment === 3 && accnum.charAt(0) === '9'
                        ? accnum.substr(4)
                        : accnum.substr(-10);
        const modResult = bank.type === 1 && bank.comment === 1
            ? Util.mod11((clearing + number).substr(-10))
            : bank.type === 1 && bank.comment === 2
                ? Util.mod11((clearing + number))
                : bank.type === 2 && bank.comment === 2
                    ? Util.mod11(number)
                    : Util.mod10(number) && (clearing.charAt(0) === '8' ? Util.mod10(clearing) : true);
        return !modResult
            ? false
            : {
                bankName: bank.name,
                clearingNumber: clearing,
                accountNumber: number
            };
    }
    isValidClearingNumber(value) {
        return /^(8?\d{4}|8\d{3}-\d)$/.test(value);
    }
    static isValidShortPersonalIdFormat(value) {
        return value.split('-')[0].length === 6 && value.split('-')[1]?.length === 4;
    }
    static isValidLongPersonalIdFormat(value) {
        return /^([12][09][0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])([\d]{4})$/.test(value);
    }
    // Note: Probably this functions can be merged
    static isValidCheckSumOfLongPersonalId(value) {
        const sum = value.split('')
            .slice(2, 12)
            .reverse()
            .map(n => Number(n))
            .reduce((previous, current, index) => {
            if (index % 2)
                current *= 2;
            if (current > 9)
                current -= 9;
            return previous + current;
        });
        return sum % 10 === 0;
    }
    static isValidCheckSumOfShortPersonalId(value) {
        const idNumber = value.replace(/\D/g, '').split('');
        if (idNumber.length !== 10) {
            return false;
        }
        const result = idNumber
            .map((c, idx) => (idx % 2 === 0 ? +c * 2 : +c))
            .map(n => (n > 9 ? n - 9 : n))
            .reduce((acc, val) => acc + val);
        return result % 10 === 0;
    }
}
exports.SEValidator = SEValidator;
